var _defs, _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWtbLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "29.041%",
    y1: "60.497%",
    x2: "145.46%",
    y2: "0%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087EE1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05E8BA",
    stopOpacity: 0.6,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "97.27%",
    y1: "0%",
    x2: "34.576%",
    y2: "66.539%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05E8BA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087EE1",
    stopOpacity: 0.45,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "66.973%",
    y1: "32.15%",
    x2: "50%",
    y2: "53.595%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A5A75",
    stopOpacity: 0.4,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A5A75",
    stopOpacity: 0,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.823 7.909a960.01 960.01 0 0 1 5.467 4.917c.761.62 1.248.535 1.46-.251.21-.787.706-3.29 1.485-7.506.045-.642-.279-.945-.97-.908-.69.036-3.172.867-7.442 2.493-.496.395-.496.813 0 1.255z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.339 4.763c2.326 2.073 4.663 4.171 7.01 6.295.976.794 1.6.687 1.87-.321.272-1.008.907-4.211 1.905-9.61-.061-.795-.466-1.17-1.215-1.123C11.161.05 7.971 1.1 2.34 3.156c-.635.505-.635 1.04 0 1.607z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.823 7.909a960.01 960.01 0 0 1 5.467 4.917c.761.62 1.248.535 1.46-.251.21-.787.706-3.29 1.485-7.506.045-.642-.279-.945-.97-.908-.69.036-3.172.867-7.442 2.493-.496.395-.496.813 0 1.255z",
    fill: "url(#a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.339 4.763c2.326 2.073 4.663 4.171 7.01 6.295.976.794 1.6.687 1.87-.321.272-1.008.907-4.211 1.905-9.61-.061-.795-.466-1.17-1.215-1.123C11.161.05 7.971 1.1 2.34 3.156c-.635.505-.635 1.04 0 1.607z",
    fill: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "normal"
    },
    d: "m0 7.033 3.39-1.275 4.875 4.343L7.525 14z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1E202A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.18 11.485 1.531-4.799 1.455 4.8h3.256l2.883-8.983h-2.883l-1.66 5.171-1.57-5.17h-2.794l-1.66 5.106-1.57-5.107H16.04l2.883 8.982h3.256zm11.704 0 .605-1.565h3.424l.605 1.565h3.14L37.72 2.503h-2.986l-3.939 8.982h3.09zm3.192-3.746h-1.75L36.2 5.48l.875 2.259zm9.968 3.746V8.226l3.398-5.723h-2.935L45.654 5.61l-1.841-3.106h-3.205l3.398 5.685v3.297h3.038zm8.641 0V4.851h2.639V2.503h-8.315v2.348h2.639v6.634h3.037zm8.14.206c.97 0 1.84-.201 2.613-.603a4.539 4.539 0 0 0 1.815-1.675c.437-.714.656-1.52.656-2.419 0-.898-.219-1.704-.656-2.418A4.539 4.539 0 0 0 66.438 2.9c-.773-.402-1.643-.603-2.613-.603s-1.84.201-2.613.603a4.539 4.539 0 0 0-1.815 1.675c-.438.714-.656 1.52-.656 2.418 0 .899.218 1.705.656 2.42a4.539 4.539 0 0 0 1.815 1.674c.772.402 1.643.603 2.613.603zm0-2.451c-.378 0-.719-.092-1.023-.276a1.978 1.978 0 0 1-.728-.783c-.18-.338-.27-.733-.27-1.187 0-.453.09-.849.27-1.187.18-.337.423-.598.728-.782a1.941 1.941 0 0 1 1.023-.276c.377 0 .719.092 1.023.276.305.184.547.445.727.782.18.338.27.734.27 1.187 0 .454-.09.85-.27 1.187-.18.338-.422.6-.727.783a1.941 1.941 0 0 1-1.023.276zm11.383 2.245c1.236 0 2.18-.216 2.832-.648.652-.432.978-1.041.978-1.828 0-.53-.146-.984-.438-1.36-.291-.377-.703-.663-1.235-.86.412-.205.723-.475.933-.808.21-.334.315-.71.315-1.13 0-.71-.307-1.278-.92-1.706-.614-.428-1.521-.642-2.722-.642h-4.814v8.982h5.071zm-.67-5.53h-1.415V4.621h1.416c.66 0 .99.222.99.667 0 .445-.33.667-.99.667zm.413 3.413h-1.828V7.957h1.828c.669 0 1.004.235 1.004.706 0 .47-.335.705-1.004.705zm8.294 2.117V2.503h-3.038v8.982h3.038zm8.693 0V9.137H87.87V2.503h-3.037v8.982h7.105zm8.062 0V9.137h-4.067V2.503h-3.038v8.982H100z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWtbLogo);
export { ForwardRef as ReactComponent };